var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4 7.2H19.2C19.64 7.2 20 7.56 20 8C20 8.44 19.64 8.8 19.2 8.8H18.4V17.6C18.4 18.9232 17.3232 20 16 20H8C6.6768 20 5.6 18.9232 5.6 17.6V8.8H4.8C4.36 8.8 4 8.44 4 8C4 7.56 4.36 7.2 4.8 7.2H5.6H8.8V5.8624C8.8 4.8352 9.6968 4 10.8 4H13.2C14.3032 4 15.2 4.8352 15.2 5.8624V7.2H18.4ZM10.8 5.6C10.5712 5.6 10.4 5.7384 10.4 5.8624V7.2H13.6V5.8624C13.6 5.7384 13.4288 5.6 13.2 5.6H10.8ZM14.4 16C14.84 16 15.2 15.64 15.2 15.2V12C15.2 11.56 14.84 11.2 14.4 11.2C13.96 11.2 13.6 11.56 13.6 12V15.2C13.6 15.64 13.96 16 14.4 16ZM10.4 15.2C10.4 15.64 10.04 16 9.6 16C9.16 16 8.8 15.64 8.8 15.2V12C8.8 11.56 9.16 11.2 9.6 11.2C10.04 11.2 10.4 11.56 10.4 12V15.2Z",
    fill: "#858EBD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_110_3416",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4 7.2H19.2C19.64 7.2 20 7.56 20 8C20 8.44 19.64 8.8 19.2 8.8H18.4V17.6C18.4 18.9232 17.3232 20 16 20H8C6.6768 20 5.6 18.9232 5.6 17.6V8.8H4.8C4.36 8.8 4 8.44 4 8C4 7.56 4.36 7.2 4.8 7.2H5.6H8.8V5.8624C8.8 4.8352 9.6968 4 10.8 4H13.2C14.3032 4 15.2 4.8352 15.2 5.8624V7.2H18.4ZM10.8 5.6C10.5712 5.6 10.4 5.7384 10.4 5.8624V7.2H13.6V5.8624C13.6 5.7384 13.4288 5.6 13.2 5.6H10.8ZM14.4 16C14.84 16 15.2 15.64 15.2 15.2V12C15.2 11.56 14.84 11.2 14.4 11.2C13.96 11.2 13.6 11.56 13.6 12V15.2C13.6 15.64 13.96 16 14.4 16ZM10.4 15.2C10.4 15.64 10.04 16 9.6 16C9.16 16 8.8 15.64 8.8 15.2V12C8.8 11.56 9.16 11.2 9.6 11.2C10.04 11.2 10.4 11.56 10.4 12V15.2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_110_3416)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete_Icon.d1b0d55d0f50df3dbf21930c1846919d.svg";
export { ForwardRef as ReactComponent };